export default __webpack_public_path__ + "static/bg-cultura-ed7431e153891d12c5afaac64bcafc68.png";